import { API_END_POINT } from "../../Api/EndPoints";
import API from "../../Api/Api";

/**
 * A spa model a prospect can be "interested" in: product type 1, not hidden
 * from the catalogue (archived or admin only, as in fetchcatalogue).
 */
export const isSpaModel = (model) =>
  model.productType === 1 && !model.archived && !model.adminOnly;

export const getModels = (language) => async (dispatch) => {
  dispatch({ type: "FETCH_MODELS_LOADING" });
  try {
    const { data } = await API.get(`${API_END_POINT}api/products`);

    const modelsMap = data?.data?.map((item) => ({
      name:
        language === "en"
          ? item?.attributes?.name_en ?? item?.attributes?.name
          : item?.attributes?.name,
      code: item?.id,
      productType: item?.attributes?.productType,
      retailerPriceHT: item?.attributes?.retailerPriceHT,
      publicPriceTTC: item?.attributes?.publicPriceTTC,
      archived: item?.attributes?.archived,
      adminOnly: item?.attributes?.adminOnly,
    }));

    dispatch({
      type: "FETCH_MODELS_SUCCESS",
      payload: { modelInfos: data?.data, modelsMap },
    });
  } catch (error) {
    dispatch({ type: "FETCH_MODELS_ERROR" });
  }
};
